import { useLocation, useParams, Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { inr } from "../lib/format";

export default function OrderSuccess() {
  const { state } = useLocation();
  const { orderNumber } = useParams();
  const order = state?.order;

  return (
    <div className="max-w-2xl mx-auto px-4 py-20 text-center" data-testid="order-success">
      <CheckCircle2 className="mx-auto text-accent" size={56} />
      <h1 className="font-display text-5xl sm:text-7xl text-white uppercase tracking-tight mt-6">Order Placed</h1>
      <p className="text-zinc-400 mt-3">Thank you! Your order <span className="text-white font-semibold">{orderNumber}</span> is confirmed and will be paid via Cash on Delivery.</p>
      <p className="text-sm text-zinc-500 mt-1">A confirmation email is on its way.</p>

      {order && (
        <div className="bg-zinc-900/50 border border-zinc-800 p-6 mt-8 text-left">
          <div className="space-y-3">
            {order.items.map((it, i) => (
              <div key={i} className="flex justify-between text-sm">
                <span className="text-zinc-300">{it.name} <span className="text-zinc-500">×{it.qty} {it.size ? `(${it.size})` : ""}</span></span>
                <span className="text-white">{inr(it.line_total)}</span>
              </div>
            ))}
          </div>
          <div className="flex justify-between text-lg font-bold text-white pt-4 mt-4 border-t border-zinc-800">
            <span>Total</span><span>{inr(order.total)}</span>
          </div>
        </div>
      )}

      <div className="flex gap-3 justify-center mt-8">
        <Link to="/track" className="border border-zinc-700 px-6 py-3.5 text-xs font-bold uppercase tracking-wider text-white hover:border-white" data-testid="success-track-link">Track Order</Link>
        <Link to="/shop" className="btn-accent px-6 py-3.5 text-xs font-bold uppercase tracking-wider">Continue Shopping</Link>
      </div>
    </div>
  );
}
